import React from "react";
import { Popper, PopperProps } from "@material-ui/core";

export type FilterPickerVariants = "contained" | "inlined" | "outlined";

export function getPopperComponent(props: PopperProps) {
  const { modifiers, popperOptions } = props;
  return (
    <Popper
      {...props}
      modifiers={{ ...modifiers, flip: { enabled: true } }}
      popperOptions={{
        ...popperOptions,
        placement: "bottom",
      }}
    />
  );
}

export function isOpenByDefault(variant: FilterPickerVariants) {
  switch (variant) {
    case "contained":
    case "outlined":
      return false;
    case "inlined":
      return true;
  }
}
